var windowWidth=$(window).width();
(function(){
    resize_windows();
    $(window).resize(function(){
      $('#header .toggle_bar').removeClass('active')
        if(windowWidth!=$(window).width()){
          resize_windows()
          windowWidth=$(window).width()
        }
    });

function resize_windows(){
  if($(window).width() <= 1200){
    $('#header .menu_list').hide();
    $('#header .menu_list .menu_list_bottom>li').off('mouseenter');
    $('#header .menu_list .menu_list_bottom>li').off('mouseleave');
    $('#header .menu_list .menu_list_bottom>li>span').click(function(event){
      var event = event || window.event;
      event.stopPropagation() ? event.stopPropagation() : event.cancelBubble = true
      if($(this).parent('li').hasClass('active')){
        $(this).parent('li').removeClass('active')
        $(this).parent('li').find('.drop_list_box').hide()
      }else{
        $(this).parent('li').addClass('active').siblings().removeClass('active');
        $(this).parent('li').find('.drop_list_box').show()
      }
      $(this).parent('li').siblings().find('.drop_list_box').hide();
    });
  }else{
    $('#header .menu_list').css({'display':"block"});
    $('#header .menu_list .menu_list_bottom li span').on('mouseenter',debounce(function(){
      $(this).parent('li').addClass('active').siblings().removeClass('active');
      $(this).parent('li').find('.drop_list_box').show();
      $(this).parent('li').siblings().find('.drop_list_box').hide();
    },100))
    $('#header .menu_list .menu_list_bottom li').on('mouseleave',function(){
      $(this).removeClass('active');
      $(this).find('.drop_list_box').hide();
      $(this).siblings().find('.drop_list_box').hide();
    });
  }
}

if($(window).width() <= 1200){
  $('.footer dl dt').click(function(){
    $(this).parent('dl').toggleClass('active');
  })
}
$('#header .toggle_bar').click(function(event){
  var event = window.event || event;
  event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
    if($('.menu_list').css('display')=='block'){
      $('.header_bg').removeClass('active');
    }else{
      $('.header_bg').addClass('active');
    }
    $('.menu_list').slideToggle();
    $(this).toggleClass('active')
})
// footer
$('#footer .language_box').click(function(event){
  var event = window.event || event;
  event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
    $('#footer .language_list').slideToggle()
    $('#footer .language_box').toggleClass('active');
    if(event.target.nodeName.toLowerCase() == 'li'){
      var now_language = event.target.getAttribute('data-value');
      doGTranslate(now_language);
    }
});
$(document).click(function(){
    if($(window).width()<1200){
    $('.menu_list').hide();
    $('.header_bg').removeClass('active');
    $('#header .toggle_bar').removeClass('active');
    $('#footer .language_box').removeClass('active');
    try {
      $('.recommend_topbox').hide();
    } catch (error) {
      
    }
    }
    $('.language_list').hide();
    $('#footer .language_box').removeClass('active');
})
if($(window).width() <= 1200){
  $('#footer .footer_list .footer_item').click(function(event){
    var event = window.event || event;
    event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
      $(this).find('.footer_item>ul').slideToggle();
      $(this).toggleClass('active');
  })
}

// 订阅
var reg_email = /^[a-zA-Z0-9.!#$%&amp;*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const email_number = $('.email .email_number');
const subscribeBtn = $('.footer .subscribe_btn');
const emailParent = $('.email');

// 检查元素是否存在
if (email_number.length && subscribeBtn.length && emailParent.length) {
  email_number.add(subscribeBtn).on({
        focus: function() {
            emailParent.addClass('active');
        },
        blur: function() {
            emailParent.removeClass('active');
        }
    });

    subscribeBtn.click(function(){
        if(reg_email.test(email_number.val())){
            $.ajax({
                url:'https://www.topvox.ai/api/subscribe.php',
                method:"post",
                dataType:"json",
                data:{
                    'email':email_number.val(),
                    'source':'1',
                },
                success: function(res){
                    // console.log(res);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    // console.error('请求失败:', textStatus, errorThrown);
                }
            });
            email_number.val('')
            const formSuccess = $('.form_success');
            if (formSuccess.length) {
                formSuccess.show()
            }
            const errorTipP = $('.error_tip p');
            if (errorTipP.length) {
                errorTipP.hide()
            }
        } else {
            if(email_number.val() === ''){
                const errorTipP = $('.error_tip p');
                if (errorTipP.length) {
                    errorTipP.hide()
                }
                const errorEmpty = $('.error_tip .error_empty');
                if (errorEmpty.length) {
                    errorEmpty.show() 
                }
            } else if(!reg_email.test(email_number.val())){
                const errorTipP = $('.error_tip p');
                if (errorTipP.length) {
                    errorTipP.hide()
                }
                const errorWrong = $('.error_tip .error_wrong');
                if (errorWrong.length) {
                    errorWrong.show()
                }
            }
        }
    })
}

// 关闭
const formSuccessClose = $('.form_success>div .close');
if (formSuccessClose.length) {
    formSuccessClose.click(function(){
        const formSuccess = $('.form_success');
        if (formSuccess.length) {
            formSuccess.hide()
        }
    })
}

// 防抖
function debounce(fn,speed){
  var timer = null;
  return function(){
    var that  = this;
    var arg = arguments;
    setTimeout(timer);
    if(!timer){
        setTimeout(function(){fn.apply(that,arg)},speed)
    }
  }
};
})(windowWidth);


//gotop
(function(){
  $('body').append('<i class="gotop"></i>');
  $(window).scroll(function(){
      if($(document).scrollTop()>=400){
          $('.gotop').show();
          $('.gotop').click(function(){
              $("body,html").scrollTop(0);
          })
      }else{$('.gotop').hide();};
  });
})();

(function(){
//系统识别
function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
if(system_confirm()=="mac"&&device_confirm()){var isMac=true}
else if(system_confirm()=="win"&&device_confirm()){var isMac=false}
if(device_confirm()==true){var device_id=true}
else if(device_confirm()==false){var device_id=false}else{};
function system_fn(){
    if (isMac == true) {
        $('.mac_btn').addClass('active').siblings('.win_btn').removeClass('active');
        $('.sys_mac').addClass('active').siblings('.sys_win').removeClass('active');
    } else if (!isMac == true) {
        $('.sys_win').addClass('active').siblings('.mac_btn').removeClass('active');
        $('.win_btn').addClass('active').siblings('.sys_mac').removeClass('active');
    } else if (device_id == false) {
        $('.pc_btn').css({"display":"none"});
        $('.mac_inline').css({"display":"none"});
        $('.win_inline').css({"display":"inline-block"});
    };
};
system_fn();
})();


// 促销
$(document).ready(function() {
  let isAnimated = false;
  let lastScrollTop = 0;
  function handleSpecialBoxAnimation() {
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const specialBox = $('.special_box');
  
      if (scrollTop > windowHeight && scrollTop > lastScrollTop) {
          if (!isAnimated) {
              specialBox.removeClass('reverse').addClass('animate');
              isAnimated = true;
          }
      } 
      else if (scrollTop <= windowHeight && scrollTop < lastScrollTop) {
          if (isAnimated) {
              specialBox.removeClass('animate').addClass('reverse');
              isAnimated = false;
          }
      }
      lastScrollTop = scrollTop;
  }
  
  function initSpecialBox() {
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const specialBox = $('.special_box');
      
      if (scrollTop > windowHeight) {
          specialBox.addClass('animate');
          isAnimated = true;
      } else {
          specialBox.removeClass('animate reverse');
          isAnimated = false;
      }
  }
  $('.special_box .close').click(function(e) {
      $('.special_box').hide();
  })
  $(window).on('scroll', handleSpecialBoxAnimation);
  initSpecialBox();
  $(window).on('resize', function() {
      initSpecialBox();
  });
});


// 打点
window.manage=function(operation,data){
  try{
      dataLayer.push({
          'event':'dotting',
          'name':'www',
          'operation':operation,
          'lable':String(data)
      })
  }catch(e){
      console.log(e);
  }
}